function NoPage(){
    return (
        <>
            <div>

                <h1 className="text-center font-custom text-5xl">THIS PAGE DOESN'T EXIST!</h1>


            </div>
        </>
    )
}


export default NoPage